// extracted by mini-css-extract-plugin
export default {"root_menu_logo":"RootMenuLogo_root_menu_logo__stzxq","spin":"RootMenuLogo_spin__oNYUq"};